import { components } from 'react-select';

const ReactSelectIndicatorSeparator = components.IndicatorSeparator;

/**
 * @typedef {import('react-select').IndicatorSeparatorProps} IndicatorSeparatorProps
 */

/**
 * @param {IndicatorSeparatorProps} props
 * @returns {JSX.Element|null}
 */
export const IndicatorSeparator = (props) => {
  const { hasValue, isDisabled, selectProps } = props;
  const shouldShowSeparator = selectProps?.isClearable && hasValue && !isDisabled;

  if (!shouldShowSeparator) {
    return null;
  }

  return <ReactSelectIndicatorSeparator {...props} />;
};
